import { useCallback, useEffect, useState } from 'react';

import { setAdFree, useAdFree } from './adFree';
import { config } from './config';
import {
    buyLifetime,
    initLifetime,
    lifetimeSupported,
    restoreLifetime,
} from './lifetime';

/** State and actions for the lifetime unlock. `supported` is false on the web, where there is nothing to buy. */
export const useLifetime = () => {
    const owned = useAdFree();
    const supported = lifetimeSupported();
    const [price, setPrice] = useState(config.lifetimeFallbackPrice);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!supported) return;
        void initLifetime({
            onOwned: () => {
                setAdFree(true);
                setBusy(false);
            },
            onPrice: setPrice,
            onError: (m) => {
                setError(m);
                setBusy(false);
            },
        });
    }, [supported]);

    const run = useCallback(
        async (action: () => Promise<string | undefined>) => {
            setBusy(true);
            setError(null);
            const failure = await action();
            if (failure) setError(failure);
            // On success the store reports ownership through the listener, which clears `busy`.
            if (failure) setBusy(false);
            else window.setTimeout(() => setBusy(false), 8000);
        },
        []
    );

    return {
        supported,
        owned,
        price,
        busy,
        error,
        buy: () => run(buyLifetime),
        restore: () => run(restoreLifetime),
    };
};
